<template>
  <div>
    <!--预约-->
    <div class="predictBlock" v-if="show">
      <div class="predictCotent">
        <div class="predicthead">
          <img class="time" src="" alt="">
          <i class="glwpc-web-icon- z-clock"></i>
          <span>预约试驾</span>
          <img class="predictDownA" src="/static/images/common/down.png" alt="" @click="toggleTestDrive">
        </div>
        <div>欢迎您在线预约试驾，吉利很重视您所提交的一切信息，这将令我们更了解您的需求和喜好，并为您提供更好的驾乘体验。</div>
        <div class="itemHead">
          <span class="title">车型选择 <span class="must">*</span></span>
        </div>

        <div class="row an-appointment">
          <div class="col-sm-6">
            <select class="form-control" name="product" v-model="product" @change="productChange(product)">
              <option
                :value="data"
                :key="data.seriesCode"
                :label="data.seriesName"
                v-for="data in productList">{{ data.seriesName }}
              </option>
            </select>
          </div>
        </div>
        <p v-if="product.seriesCode === 'ge11-pass'" class="alert-red-color">* GE11上市前暂不接受预约试驾，具体试驾时间可咨询当地经销商</p>
        <div class="itemHead">
          <span class="title">选择经销商 <span class="must">*</span></span>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <select class="form-control" name="" v-model="provData" @change="provinceChange">
              <option
                :key="data.provinceId"
                :value="data"
                :label="data.regionName"
                v-if="provinceList && provinceList.length > 0"
                v-for="data in provinceList">
                {{ data.regionName }}
              </option>
            </select>
          </div>
          <div class="col-sm-6">
            <select class="form-control" name="" v-model="cityData" @change="cityChange">
              <option
                :value="data"
                :key="data.regionId"
                :label="data.regionName"
                v-if="cityList && cityList.length > 0"
                v-for="data in cityList">
                {{ data.regionName }}
              </option>
            </select>
          </div>
          <div class="col-sm-12" v-if="1 > 2">
            <select class="form-control" name="" v-model="dealer">
              <option
                :value="data"
                :key="data.dealerId"
                :label="data.dealerName"
                v-for="data in dealerList">
                {{ data.dealerName }}
              </option>
            </select>
          </div>
          <div class="form-item col-sm-12">
            <div class="ddl" :class="{ disableColor: product.seriesCode === 'ge11-pass'}" >
              <a @click="ddlOpen = !ddlOpen">
                <span>{{ dealer ? dealer.dealerName : '选择经销商' }}</span>
                <i class="caret"></i>
              </a>
              <div class="ddl-body at-top" tabindex="-1" v-if="ddlOpen">
                <div class="filter" style="display:none">
                  <a class="active">
                    综合
                    <i class="glfico-arrowsdown"></i>
                  </a>
                  <a>
                    好评
                    <i class="glfico-arrowsdown"></i>
                  </a>
                  <a>
                    距离
                    <i class="glfico-arrowsdown"></i>
                  </a>
                </div>
                <ul>
                  <li v-if="dealerList && dealerList.length > 0 && product.seriesCode !== 'ge11-pass'" v-for="item in dealerList" :key="item.id" :data-text="item.dealerName" :data-value="item.dealerName" @click="ddlToggle(item)">
                    <div class="agency-wrapper">
                      <div class="agency">
                        <p class="agency-name">{{ item.dealerName }}</p>
                        <p class="agency-addr">
                          <i class="glfico-map"></i>
                          地址：{{ item.address }}
                        </p>
                      </div>
                      <div class="agency-city">城市:&nbsp;{{ cityData.regionName }}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="itemHead">
          <span class="title">联系方式</span><span class="span2">（*为必填信息请确保信息准确无误） </span>
        </div>
        <div class="row formBlock1">
          <div class="col-sm-6 flex-content">
            <label class="col-sm-4 formBlock1-label padding-0">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名 <span class="must">*</span> </label>
            <div class="col-sm-7 padding-0 margin-bottom-0">
              <input class="form-control" type="text" v-model="realName" placeholder="请输入您的姓名">
            </div>
          </div>
          <div class="col-sm-6 flex-content">
            <label class="col-sm-4 formBlock1-label padding-0">称&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;谓 <span class="must">*</span></label>
            <div class="col-sm-7 padding-0 margin-bottom-0">
              <label class="radio-inline">
                <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1" checked="checked"> 先生
              </label>
              <label class="radio-inline">
                <input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="2"> 女士
              </label>
            </div>
          </div>
          <div class="col-sm-6 flex-content">
            <label class="col-sm-4 formBlock1-label padding-0">手&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;机 <span class="must">*</span></label>
            <div class="col-sm-7 padding-0 margin-bottom-0">
              <input class="form-control" type="text" v-model="phoneNum" placeholder="请输入您的手机号码">
            </div>
          </div>
          <div class="col-sm-6 flex-content">
            <label class="col-sm-4 formBlock1-label padding-0">电子邮件</label>
            <div class="col-sm-7 padding-0 margin-bottom-0">
              <input class="form-control" type="text" v-model="email" placeholder="请输入您的电子邮件">
            </div>
          </div>
          <div class="policy">
            <input type="checkbox" :checked="isChecked" @click="handleChangeChecked" style="position:relative;top:.03rem;cursor:pointer;">
            我已阅读并了解本网站的<span @click="jumpPolicy" class="blue-txt">《隐私政策》。</span>本网站承诺将严格保障您的个人信息。
          </div>
        </div>
        <div class="preBottom">
          <div class="pre-bottom">
            <div>
              <img class="qrImg" src="/static/images/common/qr-pre.jpg" alt="">
            </div>
            <div class="qr-info">
              <div>
                <p>扫描二维码，关注官方微信 <br>了解更多资讯，跟预约状态 </p>
              </div>
            </div>
          </div>
          <a v-if="product.seriesCode === 'ge11-pass'" disabled href="javaScript:void(0)" class="btn-pre" :class="{'disableColor':product.seriesCode === 'ge11-pass'}" @click="predictCommit">立即预约</a>
           <a v-else href="javaScript:void(0)" class="btn-pre" :class="{'disableColor':product.seriesCode === 'ge11-pass'}" @click="predictCommit">立即预约</a>
        </div>
      </div>
      <div class="mask" v-if="show" @click="toggleTestDrive"></div>
    </div>
    <div class="map-hidden"></div>
  </div>
</template>
<script>
  import api from '../../util/api.js'
  import $ from 'jquery'
  import AMap from 'AMap'
  export default {
    name: 'TestDrive',
    data() {
      return {
        show: false,
        ddlOpen: false,
        curLocalInfo: {
          currentlocal: {
            longitude: null,
            latitude: null
          },
          provinceName: null,
          cityName: null
        },
        toolbarShow: true,
        provinceList: [],
        cityList: [],
        dealerList: [],
        productList: [],
        trailProductList: [],
        skuList: [],
        dealer: null,
        product: '',
        skuCode: '',
        realName: '',
        phoneNum: '',
        email: '',
        provData: null,
        cityData: null,
        mt: 'geelymall',
        isChecked: false
      }
    },
    created() {
      this.show = this.$store.state.testDrive.show;
      const that = this;
      that.getProductList();
      const mapObj = new AMap.Map('iCenter');
      mapObj.plugin('AMap.Geolocation', function () {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：无穷大
          maximumAge: 0,           //定位结果缓存0毫秒，默认：0
          convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true,        //显示定位按钮，默认：true
          buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true     //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        });
        mapObj.addControl(geolocation);
        geolocation.getCurrentPosition();
        AMap.event.addListener(geolocation, 'complete', function (result) {
          if (!result.addressComponent) {
            that.MainShowCityInfo();
            return false;
          }
          that.curLocalInfo.currentlocal.longitude = result.position.getLng();
          that.curLocalInfo.currentlocal.latitude = result.position.getLat();
          that.curLocalInfo.provinceName = result.addressComponent.province;
          if (result.addressComponent.city === '') {
            that.curLocalInfo.cityName = result.addressComponent.province;
          } else {
            that.curLocalInfo.cityName = result.addressComponent.city;
          }
          that.getProvList();
        });//返回定位信息
        AMap.event.addListener(geolocation, 'error', function (error) {
          that.curLocalInfo.currentlocal.longitude = 120.225651;
          that.curLocalInfo.currentlocal.latitude = 30.214795;
          that.curLocalInfo.provinceName = '浙江省';
          that.curLocalInfo.cityName = '杭州市';
          that.getProvList();
          console.log(error);
        });//返回定位出错信息
      });
      /*api.product.listAllCarInfo().then(response => {
        if (response.data.code === 'success') {
          console.log("listAllCarInfo response success");
          that.trailProductList = response.data.data;
          // that.product = response.data.data[0];
        }
      }).catch(() => {
        console.log("网络异常");
      });*/
    },
    methods: {
      jumpPolicy() {
        this.$router.push({
          path: '/policy'
        })
        this.$store.dispatch('toggleTestDrive');
      },
      toggleTestDrive() {
        this.$store.dispatch('toggleTestDrive');
      },
      MainShowCityInfo() {
        const that = this;
        AMap.service(["AMap.CitySearch"], function () {
          const citysearch = new AMap.CitySearch();
          citysearch.getLocalCity(function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.city && result.bounds) {
                that.curLocalInfo.currentlocal.longitude = result.position.getLng();
                that.curLocalInfo.currentlocal.latitude = result.position.getLat();
                that.curLocalInfo.provinceName = result.addressComponent.province;
                that.curLocalInfo.cityName = result.addressComponent.city;
              }
            } else {
              that.curLocalInfo.currentlocal.longitude = 120.225651;
              that.curLocalInfo.currentlocal.latitude = 30.214795;
              that.curLocalInfo.provinceName = '浙江省';
              that.curLocalInfo.cityName = '杭州市';
            }
            that.getProvList();
          });
        });
      },
      toggle() {
        this.$store.dispatch('contactBoxShowChange');
      },
      toggleTrial() {
        this.$store.dispatch('trailBoxShowChange');
      },
      getProvList() {
        let that = this;
        api.order.getProvList().then(response => {
          if (response.data.code === 'success') {
            console.log("province response success");
            that.provinceList = response.data.data;
            if (that.curLocalInfo.provinceName && that.curLocalInfo.cityName) {
              const curProvince = that.provinceList.filter(item => that.curLocalInfo.provinceName === item.regionName);
              that.provData = curProvince[0];
              that.provinceChange();
            }
          }
        }).catch(() => {
          console.log("网络异常");
        });
      },
      provinceChange() {
        let that = this;
        that.dealerList = [];
        that.dealer = null;
        let data = {};
        data.provId = that.provData.regionId;
        api.order.getCityList(data).then(response => {
          if (response.data.code === 'success') {
            console.log("city response success");
            that.cityList = response.data.data;
            if (that.curLocalInfo.provinceName && that.curLocalInfo.cityName) {
              const curCity = that.cityList.filter(item => that.curLocalInfo.cityName === item.regionName);
              that.cityData = curCity[0];
              that.cityChange();
            }
          }
        }).catch(() => {
          console.log("网络异常");
        });
      },
      cityChange() {
        let that = this;
        let data = {};
        data.province = that.provData.regionId;
        data.city = that.cityData.regionId;
        data.seriesCode = this.product.seriesCode;
        that.dealer = null;
        api.order.getDealerList(data).then(response => {
          if (response.data.code === 'success') {
            console.log("Dealer response success");
            that.dealerList = response.data.data;
            that.curLocalInfo.provinceName = null;
            that.curLocalInfo.cityName = null;
          }
        }).catch(() => {
          console.log("网络异常");
        });
      },
      ddlToggle(item) {
        this.dealer = null;
        this.dealer = item;
        this.ddlOpen = !this.ddlOpen;
      },
      getProductList() {
        let that = this;
        let data = {};
        data.pageNo = 1;
        data.pageSize = 30;
        api.integration.getSeriesInfo().then(response => {
          if (response.data.code === 'success') {
            console.log("getProductList response success");
            that.productList = response.data.data;
            that.product = response.data.data[0];
          }
        }).catch(() => {
          console.log("网络异常");
        });
      },
      productChange(item) {
        let that = this;
        that.dealer = null;
        let data = {};
        data.productId = that.product.seriesCode;
        if (that.provData.regionId && that.cityData.regionId) {
          this.cityChange();
        } else {

        }
        // api.product.getSkuByProductId(data).then(response => {
        //   if (response.data.code === 'success') {
        //     console.log("getSku response success");
        //
        //     that.skuList = response.data.data;
        //   }
        // }).catch(() => {
        //   console.log("网络异常");
        // });
      },
      predictCommit() {
        if (this.product.seriesCode === 'ge11-pass') {
          return false;
        }
        let that = this;
        let gender = $("input[name='inlineRadioOptions']:checked").val();
        if (that.realName === '') {
          that.$alert("请输入您的真实姓名！");
          return;
        }
        if ((/^[1][2,3,4,5,6,7,8,9][0-9]{9}$/.test(that.phoneNum)) === false) {
          that.$alert("请输入正确的手机号码！");
          return;
        }
        if (/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(this.email) === false && this.email !== "") {
          this.$alert("请输入正确的邮箱！");
          return;
        }
        if (that.product === null) {
          this.$alert("请选择车型！");
          return;
        }
        if (that.dealer === null) {
          this.$alert("请选择经销商！");
          return;
        }
        if (this.isChecked === false) {
          this.$alert("请先阅读并同意《隐私政策》");
          return;
        }
        let params = {};
        if (window.sessionStorage.getItem('yjmt')) {
          params.mt = window.sessionStorage.getItem('yjmt');
        } else {
          params.mt = that.mt;
        }
        params.dealerId = that.dealer.dealerId.toString();
        params.dealerCode = that.dealer.dealerCode.toString();
        params.dealerName = that.dealer.dealerName.toString();
        params.gender = parseInt(gender);
        params.productId = '';
        params.seriesId = that.product.seriesCode;
        params.province = that.provData.regionId.toString();
        params.provinceName = that.provData.regionName;
        params.city = that.cityData.regionId.toString();
        params.cityName = that.cityData.regionName;
        params.name = that.realName;
        params.phone = that.phoneNum;
        params.email = that.email;
        api.memberPredict(params).then(response => {
          if (response.data.code === 'success') {
            window.SCBeacon.trackGoal('G_MALL_HOME_ORDER_COMMIT');
			  const order = `试驾${Date.now()}`
			  window._gsq.push(["T", "GWD-002936", "addOrder", order]);
			  window._gsq.push(["T", "GWD-002936","setEcomProperty", order, "9", "吉利商城"]);
			  window._gsq.push(["T", "GWD-002936", "trackECom"]);
            that.$alert("预约成功！");
          } else {
            that.$alert("预约失败，请核对您的信息是否准确！");
          }
        }).catch(() => {
          console.log("网络异常");
        });
      },
      trailProductChanged() {
        let that = this;
        let data = {};
        data.productId = that.trail.product.productId;
        api.purchaseBudget.getCarNameByProductId(data).then(response => {
          if (response.data.code === 'success') {
            console.log("getSku response success");
            that.trail.skuList = response.data.data.carName;
            that.trail.periodList = [];
            that.trail.carName = null;
            that.getTrailResult();
          }
        }).catch(() => {
          console.log("网络异常");
        });
      },
      trailSkuChanged() {
        let that = this;
        that.trail.periodList = [];
        that.trail.period = null;
        // this.trail.skuPrice = this.trail.skuList.find((item) => item.skuCode == that.trail.skuCode).price;
        // this.trail.carName = this.trail.skuList.find((item) => item.skuCode == that.trail.skuCode).skuName;
        that.getTrailResult();
      },
      getTrailResult() {
        let that = this;
        that.trail.downPaymentAmount = null;
        that.trail.loanAmount = null;
        that.trail.accrual = null;
        that.trail.monthlyPaymentAmount = null;
        if (event.target.name === 'bank' || event.target.name === 'downPaymentRatio') {
          if (that.trail.product && that.trail.bank && that.trail.downPaymentRatio && that.trail.carName) {
            console.log('get period')
            that.trail.calculated = false;
            api.purchaseBudget.getBudgetPeriod({
              productId: that.trail.product.productId,
              bank: that.trail.bank,
              downPaymentRatio: that.trail.downPaymentRatio,
              carName: that.trail.carName
            }).then(response => {
              if (response.data.code === 'success') {
                that.trail.periodList = [];
                for (let val of response.data.data.period) {
                  that.trail.periodList.push(val);
                }
                that.trail.calculated = true;
              }
            }).catch(error => {
              console.log('网络异常', error)
            })
          }
        } else if (event.target.name === 'period') {
          if (that.trail.product && that.trail.bank && that.trail.downPaymentRatio && that.trail.carName && that.trail.period) {
            api.purchaseBudget.getBudget({
              sersName: that.trail.product.name,
              carName: that.trail.carName,
              bank: that.trail.bank,
              period: that.trail.period,
              downPaymentRatio: that.trail.downPaymentRatio
            }).then(response => {
              if (response.data.code === 'success') {
                that.trail.downPaymentAmount = response.data.data.downPaymentAmount;
                that.trail.loanAmount = response.data.data.loanAmount;
                that.trail.accrual = response.data.data.accrual;
                that.trail.monthlyPaymentAmount = response.data.data.monthlyPaymentAmount;
              }
            }).catch(error => {
              console.log(error)
            })
          }
        }
        // if (!that.trail.product || !that.trail.skuCode || !that.trail.bank || !that.trail.downPaymentRatio || !that.trail.period) {
        //   return false;
        // } else {
        //   api.purchaseBudget.getBudget({
        //     sersName: that.trail.product.name,
        //     skuCode: that.trail.skuCode,
        //     bank: that.trail.bank,
        //     downPaymentRatio: that.trail.downPaymentRatio,
        //     period: that.trail.period
        //   }).then((response) => {
        //     that.trail.downPaymentAmount = response.data.data.downPaymentAmount;
        //     that.trail.loanAmount = response.data.data.loanAmount;
        //     that.trail.accrual = response.data.data.accrual;
        //     that.trail.monthlyPaymentAmount = response.data.data.monthlyPaymentAmount;
        //     that.trail.calculated = true;
        //   }).catch(() => {
        //     console.log("网络异常");
        //   });
        // }
      },
      loanPay() {
        let that = this;
        that.trail.payAll = false;
      },
      fullPay() {
        let that = this;
        that.trail.payAll = true;
        localStorage.removeItem("trailResult");
      },
      buyNow() {
        let that = this;
        if (!that.trail.payAll) {
          if (!that.trail.product) {
            that.$alert("请选择车系");
            return;
          }
          if (!that.trail.product) {
            that.$alert("请选择车型");
            return;
          }
          if (!that.trail.bank) {
            that.$alert("请选择金融机构");
            return;
          }
          if (!that.trail.downPaymentRatio) {
            that.$alert("请选择首付比例");
            return;
          }
          if (!that.trail.calculated) {
            that.$alert("正在计算金融方案，请稍等...");
            return;
          }
          let trailResult = {
            product: that.trail.product,
            skuCode: that.trail.skuCode,
            bank: that.trail.bank,
            downPaymentRatio: that.trail.downPaymentRatio,
            period: that.trail.period,
            downPaymentAmount: that.trail.downPaymentAmount,
            loanAmount: that.trail.loanAmount,
            accrual: that.trail.accrual,
            monthlyPaymentAmount: that.trail.monthlyPaymentAmount
          };
          localStorage.setItem("trailResult", JSON.stringify(trailResult));
        } else {
          localStorage.removeItem("trailResult");
        }
        let product = {productId: that.productId};
        that.$router.push({
          name: "Order",
          query: product
        });
      },
      gotoZixun() {
        let id = this.$store.state.headChange.member.id;//用户id
        if (id) {
          let mobile = this.$store.state.headChange.member.username;//手机
          let realname = this.$store.state.headChange.member.realName;//用户姓名
          window.open("http://webchat.geely.com:81/hiappChat/TestEntry/customer?customerId=" + id + "&customerName=" + realname + "&mobile=" + mobile);
        } else {
          this.$router.push('/login');
        }
      },
      handleChangeChecked() {
        this.isChecked = !this.isChecked
      }
    },
    computed: {
      showTestDrive() {
        return this.$store.state.testDrive.show;
      },
      contactBoxShow() {
        return this.$store.state.Index.contactBoxShow;
      },
      trailBoxShow() {
        return this.$store.state.Index.trailBoxShow;
      },
      payAmount() {
        if (this.trail.payAll) {
          if (!this.trail.skuCode) {
            return this.trail.skuPrice;
          } else {
            return 0;
          }
        } else {
          return this.trail.downPaymentAmount;
        }
      }
    },
    watch: {
      showTestDrive() {
        this.show = this.$store.state.testDrive.show;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import "../../../static/glficofont/glfico.less";
  .alert-red-color{
    color: #ff7575;
    line-height: 0.4rem;
  }
  .disableColor{
    background: #eee!important;
  }
  .an-appointment {
    margin-bottom: 0rem!important;
  }
  .tool {
    position: fixed;
    right: 0.2rem;
    top: 2.5rem;
    z-index: 100;
    >ul{
      margin-top:1rem;
    }
    ul {
      li {
        text-align: center;
        width: 0.7rem;
        height: 0.7rem;
        padding: 0.05rem 0;
        color: white;
        background-color: rgb(18, 29, 38);
        margin: 0.25rem 0;
        border-radius: 6px;
        opacity: 0.7;
        font-size: 0.1rem;
        a {
          width: 100%;
          height: 100%;
          color: white;
          display: inline-flex;
          flex-flow: column wrap;
          align-items: center;
          justify-content: space-between;
          font-size: 0.16rem;
          text-decoration: none;
        }
        img {
          display: flex;
          width: 40%;
          height: 45%;
          clear: both;
        }
        span {
          display: flex;
        }
      }
    }
  }
  .predictBlock {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1101;
    top: 0;
    left: 0;
    .predictCotent {
      position: relative;
      z-index: 2;
      overflow: hidden;
      overflow-y: auto;
    }
    .mask {
      width: 100%;
      height: 100%;
      position: fixed;
      background: rgba(0,0,0,0.5);
    }
    div {
      margin-bottom: 0.15rem;
    }
    input[type="text"],
    select {
      width: 100%;
      height: 0.4rem;
      padding: 0.02rem 0.1rem;
      font-size: 0.16rem;
    }
    @keyframes yuyue {
      0% {
        margin-right: -45%;
      }
      100% {
        margin-right: 0;
      }
    }
    .predictCotent {
      animation: yuyue 1s;
      width: 45%;
      background-color: white;
      float: right;
      height: 100%;
      padding: 0.5rem;
      .policy{
        margin-bottom:1.5rem;
        font-size:.2rem;
        padding-left: .2rem;
      }
      label {
        color: #333;
      }
      .predicthead {
        margin-left: -10px;
        margin-bottom: 0.3rem;
        span {
          font-size: 0.28rem;
          font-weight: bold;
          color: #333;
          display: inline-block;
          vertical-align: middle;
        }
        .z-clock {
          display: inline-block;
          vertical-align: middle;
          font-size: 0.38rem;
        }
        .time {

            display: inline-block;
            vertical-align: middle;

        }
        .predictDownA {
          margin-top: 0.1rem;
          float: right;
          cursor: pointer;
        }
      }
    }
    .itemHead {
      margin-bottom: 0.1rem;
      .title {
        font-weight: bold;
        color: #333;
        font-size: 0.18rem;
        vertical-align: bottom;
      }
      .span2 {
        font-size: 0.12rem;
        color: #888;
        vertical-align: bottom;
      }
    }
    .formBlock1 {
      > div {
        height: 0.6rem;
      }
      .formBlock1-label {
        font-size: 0.16rem;
      }
    }
    .pre-bottom {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      .qrImg {
        height: 1.7rem;
      }
      .qr-info {
        padding-left: 0.2rem;
      }
    }
    .btn-pre {
      color: #fff;
      font-size: 0.2rem;
      border-radius: 1rem;
      padding: 0.1rem 0.5rem;
      display: inline-block;
      background-color: #298ad9;
      font-weight: bold;
      text-align: center;
      margin: auto;
      width: auto;
    }
  }
  .ddl {
    position: relative;
    width: 100%;
    a {
      display: block;
      border: 1px solid #CCC;
      padding: .05rem 0.1rem;
      line-height: 0.3rem;
      position: relative;
      border-radius: 0.05rem;
      cursor: pointer;
      color: #000;
      text-decoration: none;
      .caret {
        position: absolute;
        right: 0.1rem;
        top: 50%;
      }
    }
    .ddl-body {
      position: absolute;
      width: 100%;
      max-height: 2rem;
      overflow-y: auto;
      border: 1px solid #CCC;
      border-radius: 0.04rem;
      padding: 0.1rem;
      background-color: #FFF;
      z-index: 1;
      ul {
        padding-top: 0.05rem;
        li {
          cursor: pointer;
          padding: 0.05rem 0.1rem;
          .agency-wrapper {
            position: relative;
            padding-right: 0.8rem;
            .agency {
              .agency-name {}
              .agency-addr {
                .glfico-map {
                  color: #2E6E91;
                }
              }
            }
            .agency-city {
              position: absolute;
              width: 1rem;
              top: 0;
              right: 0.05rem;
              font-size: 0.1rem;
              color: #aaa;
              text-align: right;
            }
          }
        }
      }
    }
  }
  .preBottom {
    text-align: center;
  }

  .countBlock {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1101;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .predictCotent > .row {
      margin-bottom: 0.2rem;
      > div {
        margin-bottom: 0.1rem;
      }
    }
    input[type="text"],
    select {
      width: 100%;
      height: 0.4rem;
    }
    @keyframes yuyue {
      0% {
        margin-right: -45%;
      }
      100% {
        margin-right: 0;
      }
    }
    .predictCotent {
      animation: yuyue 1s;
      width: 45%;
      background-color: white;
      float: right;
      height: 100%;
      padding: 0.5rem;
      label {
        color: #333;
      }
      .predicthead {
        margin-bottom: 0.2rem;
        span {
          font-size: 0.28rem;
          font-weight: bold;
          color: #000;
          display: inline-block;
          vertical-align: middle;
        }
        .time {
            height: 0.24rem;
           display: inline-block;
           vertical-align: middle;
           width: auto;
           margin-top: 0.03rem;
           margin-right: 0.05rem;
        }
        .predictDown {
          float: right;
          cursor: pointer;
        }
        //span{
        //    display:inline-block;
        //    vertical-align: middle;
        //}
        //span1{
        //    font-size:0.2rem;
        //    font-weight:bold;
        //    color:#000;
        //}
        //span2{
        //    font-size:0.18rem;
        //    color:#888;
        //}
      }
    }
    .itemHead {
      margin-bottom: 0.1rem;
      .title {
        font-weight: bold;
        color: #000;
        font-size: 0.1rem;
        vertical-align: bottom;
      }
      .span2 {
        font-size: 0.12rem;
        color: #888;
        vertical-align: bottom;
      }
    }
    .formBlock1 {
      > div {
        height: 0.6rem;
      }
      &.row > div {
        margin-bottom: 0.2rem;
      }
    }
    .pre-bottom {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      .qrImg {
        height: 1.7rem;
      }
      .qr-info {
        padding-left: 0.2rem;
      }
    }
    .payStyle {
      .btn {
        color: #000;
        font-size: 0.1rem;
        padding: 0.1rem 0.5rem;
        display: inline-block;
        margin-right: 0.3rem;
        border: 1px solid #ccc;
        font-weight: bold;
        text-align: center;
        margin: auto;
        width: auto;
        &.active {
          color: #fff;
          background-color: #298ad9;
          border: 1px solid #298ad9;
        }
      }
    }
    .countResult {
      margin-bottom: 0.2rem;
      .num {
        border-bottom: 1px solid #333;
        padding: 0.1rem 0 0.05rem 0;
      }
    }
    .gobuy {
      width: 100%;
      padding: 0.2rem 0;
      background-color: #298ad9;
      color: #fff;
      font-weight: bold;
      text-align: center;
      display: block;
      letter-spacing: 1px;
    }
    //  .btn-pre {
    //      color: #fff;
    //      font-size: 0.1rem;
    //      border-radius: 1rem;
    //      padding: 0.1rem 0.5rem;
    //      display: inline-block;
    //      margin-right: 0.2rem;
    //      background-color: #298ad9;
    //      font-weight: bold;
    //      text-align: center;
    //      margin: auto;
    //      width: auto;
    //  }
  }
  .countResultBlock{
    padding:0.2rem 0;
    background-color:#ddd;
    .countLabel{
      color:#555;
      width:1.2rem;
      display:inline-block;
      vertical-align:middle;
    }
    .countValue{
      color:rgb(33,150,243);
      font-weight:bold;
      font-size:0.28rem;
      display:inline-block;
      vertical-align:middle;
    }
    .countMark{
      color:#888;
      padding-left:15px;

    }
  }
  .bigLabel{
    font-size: 0.2rem;
    white-space: nowrap;
    color:#333;
    font-weight:bold;
  }
  .countBottom{
    margin:0.5rem 0;
    .totalValue{
      margin-top:0.1rem;
      color:rgb(33,150,243);
      font-size:0.4rem;
      font-weight:bold;
    }
  }
  hr{
    border-color:#ddd;
  }
  .map-hidden {
    display: none;
  }
  .margin-bottom-0 {
    margin-bottom: 0 !important;
  }
  .padding-0 {
    padding: 0;
  }
  .flex-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .blue-txt{
    color:#0067B2;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/TestDrive.vue